import { createContext } from 'react';
import { RealtimeEvent } from 'fym-shared/src/music24/realtimeEvents';

export type RealtimeListener = (event: RealtimeEvent) => void;

export interface RealtimeContextValue {
  /** True while the socket is open and the server accepted the session. */
  isConnected: boolean;
  /** Calls `listener` for each event. Returns the function that stops it. */
  subscribe: (listener: RealtimeListener) => () => void;
}

/**
 * The value with no provider (a test, a signed-out page): never connected, no events. Each poll
 * site then keeps its own interval, which is the behaviour from before the socket.
 */
export const disconnectedRealtime: RealtimeContextValue = {
  isConnected: false,
  subscribe: () => () => undefined,
};

export const RealtimeContext = createContext<RealtimeContextValue>(disconnectedRealtime);
